<script>
/**
 * @description Контейнер подключаемого раздела.
 * @type {Vue}
 */
export default {
  functional: true,
  name: 'AvailableSection',
  props: {
    section: {
      required: true,
      type: [String, Array],
    },
  },
  render(createElement, { children, parent: { $store }, props: { section } }) {
    const isAvailable = Array.isArray(section)
      ? section.every((item) => $store.getters.isSectionAvailable(item))
      : $store.getters.isSectionAvailable(section);
    if (isAvailable) {
      return children;
    }
    return createElement();
  },
};
</script>
